













import { ExportToCsv } from 'export-to-csv'
import { Vue, Component, Prop } from 'vue-property-decorator'

import { errorNotificationWrapper } from '../../logic/helpers/NotificationService'
import getAnyValue from '../../shared/utils/getAnyValue'

@Component
export default class TableExportButtons extends Vue {
  @Prop() readonly data!: any

  @Prop() readonly headers!: Array<string> | undefined

  @Prop() readonly fileName!: string

  @Prop() readonly disabled!: boolean

  async exportToCsv() {
    try {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        filename: this.fileName,
        title: this.fileName,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: this.headers === undefined,
        headers: this.headers,
      }

      new ExportToCsv(options).generateCsv(await getAnyValue(this.data))
    } catch (e) {
      errorNotificationWrapper(this.$t('error').toString(), e)
    }
  }
}
